/**
 * Detect phrasing that implies a real MIME attachment was sent with the email.
 * Yoda only embeds download links — authors should prefer “lien” / “link” wording.
 */

/** Strip combining marks so « pièce » / « attaché » match ASCII-friendly patterns. */
function foldAccents(text: string): string {
    return String(text || '')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '');
}

const PATTERNS: RegExp[] = [
    // French (accent-folded)
    /\bci[-\s]?joints?\b/i,
    /\bci[-\s]?jointes?\b/i,
    /\bpieces?[-\s]?jointes?\b/i,
    /\ben\s+piece[-\s]?jointe\b/i,
    /\ben\s+pj\b/i,
    /\bpj\s*[:：]/i,
    /\battachee?s?\b/i,
    /\bveuillez\s+trouver\s+ci[-\s]?joint\b/i,
    /\bvous\s+trouverez\s+ci[-\s]?joint\b/i,
    // English
    /\battachments?\b/i,
    /\battached\b/i,
    /\bplease\s+find\s+attached\b/i,
    /\bfind\s+attached\b/i,
    /\benclosed\b/i,
    /\bherein\s+attached\b/i,
    // German (accent-folded: beigefügt → beigefugt, angehängt → angehangt)
    /\bim\s+anhang\b/i,
    /\banbei\b/i,
    /\banlagen?\b/i,
    /\bbeigefugt\b/i,
    /\bangehangt\b/i,
    /\banliegend\b/i,
];

/**
 * Strip tags and collapse whitespace for keyword matching.
 */
export function plainTextFromHtml(html: string): string {
    return String(html || '')
        .replace(/<script[\s\S]*?<\/script>/gi, ' ')
        .replace(/<style[\s\S]*?<\/style>/gi, ' ')
        .replace(/<[^>]+>/g, ' ')
        .replace(/&nbsp;/gi, ' ')
        .replace(/\s+/g, ' ')
        .trim();
}

/**
 * Check the authored reply body only (not quoted history).
 * @returns true when the text suggests a real email attachment was promised
 */
export function detectFalseAttachmentWording(textOrHtml: string): boolean {
    const text = foldAccents(plainTextFromHtml(textOrHtml));
    if (!text)
        return false;
    return PATTERNS.some((re) => re.test(text));
}
